angular.module 'app'
.config ($stateProvider) ->
  $stateProvider
    .state 'app.msg-manage',
      url: '/msg-manage/:id'
      templateUrl: 'apps/message/msg-manage/msg-manage'
      controller: 'MsgManageCtrl'
      resolve:
        loadPlugin: ($ocLazyLoad) ->
          $ocLazyLoad.load([
              name: 'css'
              insertAfter: '#app-level'
              files: [
                'bootstrap-daterangepicker/daterangepicker.css'
                'lightgallery/dist/css/lightbox.css'
              ]
            ,
              name: 'vendors'
              insertAfter: '#app-level-js'
              files: [
                'jqueryFileDownload/jquery.fileDownload.js'
                'bootstrap-daterangepicker/daterangepicker.js'
              ]
          ])
